import { render, staticRenderFns } from "./SettingsMedias.vue?vue&type=template&id=35f5b8b9&scoped=true"
import script from "./SettingsMedias.vue?vue&type=script&lang=js"
export * from "./SettingsMedias.vue?vue&type=script&lang=js"
import style0 from "./SettingsMedias.vue?vue&type=style&index=0&id=35f5b8b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5b8b9",
  null
  
)

export default component.exports